<div class="modal-header-modern">
    <div class="modal-header-icon icon-orange">
        <i class="material-icons">security</i>
    </div>
    <div>
        <h4 class="modal-title-modern">Alterar Senha Obrigatória</h4>
        <p class="modal-subtitle-modern">Por segurança, altere sua senha no primeiro acesso</p>
    </div>
</div>

<div class="modal-body">
    <div class="container">
        <div class="alert-info-box">
            <i class="material-icons">info</i>
            <span>Detectamos que esta é sua primeira vez acessando o sistema. Para sua segurança, é obrigatório alterar a senha padrão antes de continuar.</span>
        </div>

        <form [formGroup]="senhaForm">
            <div class="row">
                <mat-form-field class="col-md-12" appearance="outline">
                    <mat-label>Senha Atual</mat-label>
                    <input matInput [type]="ocultarSenhaAtual ? 'password' : 'text'"
                        formControlName="senhaAtual" placeholder="Digite sua senha atual" />
                    <button mat-icon-button matSuffix type="button"
                        (click)="ocultarSenhaAtual = !ocultarSenhaAtual">
                        <i class="material-icons">{{ocultarSenhaAtual ? 'visibility_off' : 'visibility'}}</i>
                    </button>
                    <mat-error *ngIf="senhaForm.controls['senhaAtual'].hasError('required')">
                        Campo obrigatório
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Nova Senha</mat-label>
                    <input matInput [type]="ocultarNovaSenha ? 'password' : 'text'"
                        formControlName="novaSenha" placeholder="Mínimo 6 caracteres" />
                    <button mat-icon-button matSuffix type="button"
                        (click)="ocultarNovaSenha = !ocultarNovaSenha">
                        <i class="material-icons">{{ocultarNovaSenha ? 'visibility_off' : 'visibility'}}</i>
                    </button>
                    <mat-error *ngIf="senhaForm.controls['novaSenha'].hasError('required')">
                        Campo obrigatório
                    </mat-error>
                    <mat-error *ngIf="senhaForm.controls['novaSenha'].hasError('minlength')">
                        Mínimo de 6 caracteres
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="col-md-6" appearance="outline">
                    <mat-label>Confirmar Nova Senha</mat-label>
                    <input matInput [type]="ocultarConfirmarSenha ? 'password' : 'text'"
                        formControlName="confirmarNovaSenha" placeholder="Repita a nova senha" />
                    <button mat-icon-button matSuffix type="button"
                        (click)="ocultarConfirmarSenha = !ocultarConfirmarSenha">
                        <i class="material-icons">{{ocultarConfirmarSenha ? 'visibility_off' : 'visibility'}}</i>
                    </button>
                    <mat-error *ngIf="senhaForm.controls['confirmarNovaSenha'].hasError('required')">
                        Campo obrigatório
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="info-hint">
                <i class="material-icons">vpn_key</i>
                <span>A senha deve ter no mínimo <strong>6 caracteres</strong>. Escolha uma senha diferente da atual.</span>
            </div>
        </form>

        <ngx-loading [show]="loading"></ngx-loading>
    </div>
</div>

<div class="modal-footer-modern">
    <button type="button" class="btn-modern btn-modern-primary" (click)="confirmar()">
        <i class="material-icons">lock_reset</i> Alterar Senha e Continuar
    </button>
</div>
